// Où revenir après avoir connecté une plateforme publicitaire.
//
// Les sept pages de retour OAuth (Meta, TikTok, Snapchat, LinkedIn, Google,
// Reddit, Shopify) renvoyaient toutes en dur vers le tableau de bord. Depuis
// qu'une seconde page connecte les plateformes — /claude, pour le connecteur
// Claude — chacune doit ramener l'utilisateur là d'où il est parti.
//
// La page de départ se déclare avant d'ouvrir le tunnel OAuth ; la clé est
// consommée au retour pour ne pas influencer une connexion ultérieure lancée
// depuis le tableau de bord.
const KEY = "platformReturnTo";
const DEFAULT = "/dashboard/connected-platforms";

export const rememberReturnTo = (path) => {
  try { sessionStorage.setItem(KEY, path); } catch (e) { /* stockage indisponible : on retombera sur le tableau de bord */ }
};

export const afterPlatformConnect = () => {
  try {
    const path = sessionStorage.getItem(KEY);
    sessionStorage.removeItem(KEY);
    return path && path.startsWith("/") ? path : DEFAULT;
  } catch (e) {
    return DEFAULT;
  }
};
